/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetLayoutsByDivisionIdDivisionIdGet$Plain$Params {
  divisionId: string;
}

export function getLayoutsByDivisionIdDivisionIdGet$Plain(http: HttpClient, rootUrl: string, params: GetLayoutsByDivisionIdDivisionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getLayoutsByDivisionIdDivisionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('divisionId', params.divisionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

getLayoutsByDivisionIdDivisionIdGet$Plain.PATH = '/GetLayoutsByDivisionId/{divisionId}';
